module.exports = __webpack_public_path__ + "media/images/help/site-create-cfee0e0b729b029141a9f0cd997f711c.png";